const resource = {
  "emptyResultSubtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter player ID to download data"])},
  "emptyResultTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nothing yet"])},
  "enterId": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter player ID"])},
  "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
}
export default resource